import { createApp } from 'vue';
import vuetify from './plugins/vuetify';
import App from './App';
import router from './router';
import store from './plugins/store';
import i18n from './i18n';
import titleMixin from './plugins/htmlTitle';


require(`../public/favicon/${process.env.ProjectCode}/favicon.ico`);

const app = createApp(App);

app.mixin(titleMixin);
app.use(router);
app.use(store);
app.use(vuetify);
app.use(i18n);

app.mount('#app');